export const getProductImageSources = (product = {}) => {
  if (!product || typeof product !== 'object') {
    return {
      thumbnail: null,
      compressed: null,
      original: null,
      legacy: null,
    };
  }

  const legacy =
    typeof product.image === 'string' && product.image.startsWith('data:image/')
      ? product.image
      : null;

  const sources = {
    thumbnail: product.image_thumbnail_url || null,
    compressed: product.image_compressed_url || null,
    original: product.image_s3_url || null,
    legacy,
  };

  const withFallback = (primary, ...fallbacks) => {
    if (primary) return primary;
    for (const candidate of fallbacks) {
      if (candidate) return candidate;
    }
    return null;
  };

  return {
    thumbnail: withFallback(sources.thumbnail, sources.compressed, sources.original, sources.legacy),
    compressed: withFallback(sources.compressed, sources.original, sources.thumbnail, sources.legacy),
    original: withFallback(sources.original, sources.compressed, sources.thumbnail, sources.legacy),
    legacy: sources.legacy,
  };
};

export const getBestProductImage = (product, preferredVariant = 'compressed') => {
  const sources = getProductImageSources(product);
  if (preferredVariant && sources[preferredVariant]) {
    return sources[preferredVariant];
  }

  return (
    sources.compressed ||
    sources.thumbnail ||
    sources.original ||
    sources.legacy ||
    null
  );
};

export const productHasImage = (product) => {
  const sources = getProductImageSources(product);
  return Boolean(sources.thumbnail || sources.compressed || sources.original || sources.legacy);
};
